import { useEffect } from 'react';

import { onUnauthorized } from '@/features/agents/unauthorized';
import { useSession } from '@/features/session/SessionProvider';
import {
  attemptedRecently,
  rememberAttempt,
} from '@/features/session/attemptGuard';

/** A 401 that keeps coming back while `/agents/user` still answers would reload the page again and again. */
const CHAT_401_KEY = 'gasbi-ai.chat-401';

/**
 * A 401 from any chat request means the session has ended: the session is checked again, which signs in silently
 * (panel) or by a redirect (page), or shows «Увійти» (ADR-0004 §2.3–2.4). Once a minute, as the other loop guards.
 */
export const useRetryOnUnauthorized = () => {
  const { retry } = useSession();

  useEffect(
    () =>
      onUnauthorized(() => {
        if (attemptedRecently(CHAT_401_KEY)) return;
        rememberAttempt(CHAT_401_KEY);
        retry();
      }),
    [retry],
  );
};
